import { Vue, Options } from 'vue-class-component';
import { v4 as uuidv4 } from 'uuid';

@Options({
  name: 'EnumToRadioButton',
  props: {
    modelValue: {
      type: [String, Number],
      required: true,
    },
    enum: {
      type: Object,
      required: true,
    },
    disabledChoices: {
      type: Array,
      required: false,
    },
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue: function (newValue) {
      this.selectValue = newValue;
    },
    selectValue: function (newValue) {
      this.$emit('update:modelValue', newValue);
    },
  },
})
export default class EnumToRadioButton extends Vue {
  enum!: Object;
  disabledChoices!: Object[];
  modelValue!: string | number;

  selectValue: string | number | null = null;

  idPrefix = uuidv4();

  get selectOptions() {
    return Object.values(this.enum)
      .filter(
        (value: string | number) =>
          typeof value !== 'number' &&
          value.toLowerCase() !== 'none' &&
          (!this.disabledChoices ||
            !this.disabledChoices.includes(this.enum[value as keyof Object]))
      )
      .map((value: keyof Object) => ({
        value: this.enum[value],
        label: this.$t(`AppResource.${value}`),
      }));
  }

  created() {
    this.selectValue = this.modelValue;
  }
}
